/* Conceivable homepage logic — ported from the DC script class as a plain IIFE (handoff §4). ~180 lines, no jQuery. */
(function () {
  'use strict';
  let foodTimer;
const LENSES = [
  { color:'#E8A7D1', soft:'rgba(232,167,209,0.16)', eyebrow:'Lens 01 · Ages 9–14', score:76, title:'FIRST PERIOD', body:'A standalone, gentle beginning, for her and for the grown-up who bought it. Kai answers the questions she is too embarrassed to ask anyone else, and nothing about it feels clinical.', chips:['Kai','What is normal?','For grown-ups'], grad:'linear-gradient(168deg,#E8A7D1,#F0BDD8)', screen:'linear-gradient(180deg,#FDEFF7 0%,#F9F7F0 60%)', label:'Day 2 of your first period' },
  { color:'#E24D47', soft:'rgba(226,77,71,0.14)', eyebrow:'Lens 02 · The foundation', score:72, title:'PERIOD', body:'The base every other lens is built on. Cycle tracking, symptoms, temperature, food, supplements, your score, and a team that treats a 38-day cycle as a question worth answering.', chips:['Cycle & symptoms','Score','Olive\u2019s menus'], grad:'linear-gradient(168deg,#E24D47,#F08A85)', screen:'linear-gradient(180deg,#FDECEB 0%,#F9F7F0 60%)', label:'Cycle day 8' },
  { color:'#5A6FFF', soft:'rgba(90,111,255,0.12)', eyebrow:'Lens 03 · Trying to conceive', score:84, title:'FERTILITY', body:'Everything from your Period lens carries over. Then the app turns periwinkle and adds a readiness score, temperature curve, LH readings, a two-week-wait companion, and a partner who can see the window too.', chips:['Readiness score','Temp curve','Partner mode'], grad:'linear-gradient(168deg,#5A6FFF,#7E82E8)', screen:'linear-gradient(180deg,#EEF0FF 0%,#F9F7F0 60%)', label:'Cycle day 14' },
  { color:'#A99ECF', soft:'rgba(169,158,207,0.16)', eyebrow:'Lens 04 · Expecting', score:88, title:'PREGNANCY', body:'Week by week, with no flags and no verdicts. Symptom logging, nutrition that changes by trimester, and Kai for the nights when the worry arrives at 3am.', chips:['Week by week','Trimester food','No verdicts'], grad:'linear-gradient(168deg,#A99ECF,#C4BCE0)', screen:'linear-gradient(180deg,#F4F1FB 0%,#F9F7F0 60%)', label:'Week 21' },
  { color:'#6FA86C', soft:'rgba(111,168,108,0.14)', eyebrow:'Lens 05 · The fourth trimester', score:70, title:'POSTPARTUM', body:'Recovery, bleeding, mood, libido, feeding, and the one thing nobody else tracks: when your period actually comes back, and where you want to go next.', chips:['Recovery','Mood check-ins','Return of cycle'], grad:'linear-gradient(168deg,#6FA86C,#9ED399)', screen:'linear-gradient(180deg,#EEF6ED 0%,#F9F7F0 60%)', label:'Week 7 postpartum' },
  { color:'#E8B44A', soft:'rgba(232,180,74,0.16)', eyebrow:'Lens 06 · Coming soon', score:75, title:'MENOPAUSE', body:'Perimenopause is a decade long and almost entirely unsupported. Kai already has years of your story. This is where it finally pays off.', chips:['Coming soon','Symptom mapping','Decades of context'], grad:'linear-gradient(168deg,#E8B44A,#F2CE84)', screen:'linear-gradient(180deg,#FCF4E4 0%,#F9F7F0 60%)', label:'Cycle: irregular' }
];



  function foodSlides(){
    const slides = Array.from(document.querySelectorAll('[data-food-slide]'));
    if (slides.length < 2) return;
    let i = 0;
    foodTimer = setInterval(() => {
      i = (i + 1) % slides.length;
      slides.forEach((s, j) => { s.style.opacity = j === i ? '1' : '0'; });
    }, 5200);
  }


  function reveal(){
    const els = Array.from(document.querySelectorAll('[data-reveal]'));
    els.forEach((el, i) => { el.style.transition = 'opacity 720ms cubic-bezier(0.32,0.72,0,1), transform 720ms cubic-bezier(0.32,0.72,0,1)'; el.style.transitionDelay = (i % 4) * 70 + 'ms'; });
    const show = el => { el.style.setProperty('opacity','1','important'); el.style.setProperty('transform','none','important'); };
    if (!('IntersectionObserver' in window)) { els.forEach(show); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(el => io.observe(el));
    setTimeout(() => els.forEach(show), 4000);
  }

  function rings(){
    document.querySelectorAll('[data-ring]').forEach(c => {
      const len = parseFloat(c.getAttribute('stroke-dasharray'));
      const pct = parseFloat(c.getAttribute('data-ring'));
      const run = () => {
        c.style.transition = 'stroke-dashoffset 1500ms cubic-bezier(0.32,0.72,0,1)';
        c.style.strokeDashoffset = String(len * (1 - pct));
      };
      if (!('IntersectionObserver' in window)) { run(); return; }
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(); io.disconnect(); } }), { threshold: 0.3 });
      io.observe(c);
    });
  }

  function dashes(){
    document.querySelectorAll('[data-dash]').forEach(p => {
      const len = p.getTotalLength ? p.getTotalLength() : 0;
      if (!len) return;
      p.style.strokeDasharray = len;
      p.style.strokeDashoffset = len;
      const run = () => { p.style.transition = 'stroke-dashoffset 1800ms cubic-bezier(0.32,0.72,0,1)'; p.style.strokeDashoffset = '0'; };
      if (!('IntersectionObserver' in window)) { run(); return; }
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(); io.disconnect(); } }), { threshold: 0.25 });
      io.observe(p);
    });
  }

  function wireRing(){
    const R = [
      { stage:'Period lens', color:'#E24D47', grad:'linear-gradient(168deg,#E24D47 0%,#E8707A 100%)',
        head:'The three days before, decoded.',
        sub:'Patterns, never verdicts. Kai reads the shape of the month and adjusts what you do next.',
        lines:[['Temperature drop','The day before bleeding starts, so nothing catches you off guard.'],['Broken sleep &amp; restlessness','Which nights cramping actually cost you.'],['Glucose swings','The dips that turn into cravings, headaches and rage-by-4pm.']],
        team:'Kai reshapes the week around iron and steadier blood sugar, and shows up on the days the data says will be hard.' },
      { stage:'Fertility lens', color:'#5A6FFF', grad:'linear-gradient(168deg,#5A6FFF 0%,#7E82E8 100%)',
        head:'Ovulation, without the 6am alarm.',
        sub:'Patterns, never verdicts. Kai reads the shape of the week and adjusts the plan.',
        lines:[['Your temperature curve','Captured in your sleep. The shift shows up on its own.'],['Recovery &amp; HRV','Whether your body has the resources this cycle is asking for.'],['Glucose steadiness','The single most changeable driver of hormone rhythm.']],
        team:'Kai lines it up against your logs and changes the meals. Nothing here is a verdict about your fertility.' },
      { stage:'Pregnancy lens', color:'#A99ECF', grad:'linear-gradient(168deg,#8E7FD8 0%,#A99ECF 100%)',
        head:'Rest, when everything is changing.',
        sub:'No scores, no flags, no verdicts. Just what your nights actually looked like.',
        lines:[['Resting heart rate trend','The quiet climb that comes with a growing blood volume.'],['Fragmented sleep','Where the wake-ups cluster, so you can plan around them.'],['Glucose patterns','Context for the food conversations, not a diagnosis.']],
        team:'Kai builds around nausea and aversions. Anything clinical goes to your provider. We hand you the notes, not the call.' },
      { stage:'Postpartum lens', color:'#6FA86C', grad:'linear-gradient(168deg,#3F7A5C 0%,#6FA86C 100%)',
        head:'Recovery, measured in fragments.',
        sub:'Sleep in 90-minute pieces still counts. We measure what you actually got.',
        lines:[['Sleep in pieces','Total rest across the night, feeds included.'],['HRV depletion','How far into the tank you are, before you crash.'],['Temperature rhythm returning','The first quiet sign your cycle is coming back.']],
        team:'Kai rebuilds iron and protein for healing and supply. When the rhythm returns, the app offers you the Period lens.' },
      { stage:'Menopause lens', color:'#E8B44A', grad:'linear-gradient(168deg,#D89A2E 0%,#E8B44A 100%)',
        head:'The 3am wake-up, explained.',
        sub:'You are not imagining it. Here is the night it actually was.',
        lines:[['Night temperature spikes','Flashes mapped to the hour they happen.'],['Sleep disruption','How much the heat is really costing you.'],['Glucose sensitivity shifts','Why the food that worked at 35 does not at 49.']],
        team:'Kai changes dinner and timing, and has the language for the days that feel unfamiliar.' }
    ];
    const btns = Array.from(document.querySelectorAll('[data-ring-lens]'));
    if (!btns.length) return;
    const set = (sel, txt) => { const el = document.querySelector(sel); if (el) el.textContent = txt; };
    const select = i => {
      const L = R[i];
      btns.forEach((b, j) => {
        const on = j === i;
        b.style.setProperty('background', on ? L.color : 'transparent', 'important');
        b.style.setProperty('color', on ? '#F9F7F0' : '#4A4658', 'important');
        b.style.setProperty('border-color', on ? L.color : 'rgba(42,40,40,0.14)', 'important');
        b.style.setProperty('box-shadow', on ? '0 10px 26px ' + L.color + '4D' : 'none', 'important');
      });
      const wash = document.querySelector('[data-ring-wash]');
      if (wash) wash.style.setProperty('background', L.grad, 'important');
      set('[data-ring-stage]', L.stage);
      set('[data-ring-head]', L.head);
      set('[data-ring-sub]', L.sub);
      set('[data-ring-team]', L.team);
      const lines = document.querySelector('[data-ring-lines]');
      if (lines) lines.innerHTML = L.lines.map(([t, d]) =>
        '<div style="display:flex;gap:13px;align-items:flex-start;">'
        + '<span style="width:8px;height:8px;border-radius:50%;background:' + L.color + ';margin-top:7px;flex:none;"></span>'
        + '<div><div style="font-family:Archivo,sans-serif;font-size:14.9px;font-weight:700;color:#2A2828;">' + t + '</div>'
        + '<div style="font-size:14.9px;line-height:1.55;color:#6B6268;margin-top:3px;">' + d + '</div></div></div>').join('');
    };
    btns.forEach((b, i) => b.addEventListener('click', () => select(i)));
    select(1);
  }

  function wireLenses(){
    const btns = Array.from(document.querySelectorAll('[data-lens]'));
    const select = i => {
      const L = LENSES[i];
      document.body.style.setProperty('--accent', L.color);
      document.body.style.setProperty('--accent-soft', L.soft);
      btns.forEach((b, j) => {
        const on = j === i;
        b.style.setProperty('background', on ? L.color : 'transparent', 'important');
        b.style.setProperty('color', on ? '#F9F7F0' : '#4A4658', 'important');
        b.style.setProperty('border-color', on ? L.color : 'rgba(42,40,40,0.16)', 'important');
        b.style.setProperty('box-shadow', on ? '0 10px 26px ' + L.soft.replace('0.1','0.3') : 'none', 'important');
      });
      const set = (sel, txt) => { const el = document.querySelector(sel); if (el) el.textContent = txt; };
      set('[data-lens-eyebrow]', L.eyebrow);
      set('[data-lens-title]', L.title);
      set('[data-lens-body]', L.body);
      set('[data-lens-screen-label]', L.label);
      const chips = document.querySelector('[data-lens-chips]');
      if (chips) chips.innerHTML = L.chips.map(c => '<span style="padding:8px 15px;border-radius:999px;background:' + L.soft + ';color:' + L.color + ';font-family:Archivo,sans-serif;font-size:12.1px;font-weight:700;letter-spacing:0.09em;text-transform:uppercase;">' + c + '</span>').join('');
      const panel = document.querySelector('[data-lens-panel]');
      if (panel) panel.style.setProperty('background', L.grad, 'important');
      // real-screen swap with crossfade
      const simg = document.querySelector('[data-lens-screen-img]');
      if (simg) {
        const src = simg.getAttribute('data-src-' + i);
        if (src && simg.src !== src) {
          simg.style.opacity = '0';
          setTimeout(() => { simg.src = src; simg.style.opacity = '1'; }, 240);
        }
      }
      // animated Conceivable Score — ring draw + count-up
      const ringEl = document.querySelector('[data-lens-scorering]');
      const numEl = document.querySelector('[data-lens-scorenum]');
      if (ringEl && numEl && L.score) {
        ringEl.setAttribute('stroke', L.color);
        ringEl.style.transition = 'none';
        ringEl.style.strokeDashoffset = '157';
        requestAnimationFrame(() => {
          ringEl.style.transition = 'stroke-dashoffset 1200ms cubic-bezier(0.32,0.72,0,1)';
          ringEl.style.strokeDashoffset = String(157 * (1 - L.score / 100));
        });
        const t0 = performance.now();
        const tick = now => {
          const pr = Math.min((now - t0) / 1200, 1);
          numEl.textContent = String(Math.round(L.score * (1 - Math.pow(1 - pr, 3))));
          if (pr < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
      const screen = document.querySelector('[data-lens-screen]');
      if (screen) screen.style.setProperty('background', L.screen, 'important');
    };
    btns.forEach((b, i) => b.addEventListener('click', () => select(i)));
    select(2);
  }
  document.addEventListener('DOMContentLoaded', function () {
    reveal();
    rings();
    dashes();
    wireLenses();
    wireRing();
    foodSlides();
  });
})();
